import { color, extendTheme } from "@chakra-ui/react";

const Text = {
  sizes: {
    content: {
      fontSize: "15px",
      fontWeight: 400,
      lineHeight: "24px",
      opacity: 0.8
    },
    small: {
      fontSize: "15px",
      fontWeight: 500,
      lineHeight: "24px",
      marginBottom: "4px",
      opacity: 0.8
    },
    md: {
      fontSize: "18px",
      fontWeight: 600
    },
    big: {
      fontSize: "24px",
      fontWeight: 600
      // lineHeight: "48px"
    }
  }
};
export const theme = extendTheme({
  // colors: {
  //   text: "#000",
  //   background: "#fff"
  // },
  fonts: {
    // body: "MI Lan Pro, miui, serif",
    // heading: "MI Lan Pro, miui, serif"
    body: "inherit",      // 继承父级字体
    heading: "inherit"    // 继承父级字体
  },
  breakpoints: {
    xxxs: "360px",
    xxs: "410px",
    xs: "480px",
    sm: "670px",
    tablet: "670px",
    md: "980px",
    desktop: "1024px",
    lg: "1024px",
    xl: "1440px",
    "2xl": "1920px"
  },
  components: {
    Text
  }
  // config: {
  //   initialColorMode: "light",
  //   useSystemColorMode: false
  // }
});

// export const darkTheme = {
//   ...lightTheme,
//   colors: {
//     text: "#fff",
//     background: "#000"
//   }
// };

type MyTheme = typeof theme;

declare module "@emotion/react" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface Theme extends MyTheme {}
}
